/**
 * Returns an optimised image URL.
 * 
 * Allowed size values:
 * 'pico', 'icon', 'thumb', 'small', 'compact', 'medium', 'large', 'grande', 'original'
 * '1024x1024', '768x', 'x768'
 * https://community.shopify.com/c/Shopify-Design/We-now-have-a-new-compact-size-for-product-images/m-p/95528
 *
 * @param {string} image URL of master image 
 * @param {string} size Desired size of image, see allowed values above
 * @return {string} URL of resized image
 */

import Vue from 'vue';
import { updateUrlParameters } from '../utils/helpers';

Vue.filter('imageSize', (url, width, height = null, queries = null) => {
  const params = {
    width: Math.ceil(width),
    height: Math.ceil(height),
    ...queries
  };

  if (!url.startsWith('https:')) {
    url = `https:${url}`;
  }

  return updateUrlParameters(params, url);
});